import React, { ReactElement } from 'react';
import { DocSetEnum } from 'components/pages/documents/documents.data';
import styles from 'components/pages/documents/DocumentsBlock.module.scss';

interface AltLink {
    href: string;
    /** anglický název dokumentu (tooltip + přístupné jméno) */
    title: string;
    lang: DocSetEnum;
    /** viditelný text odznaku, např. „EN verze“ */
    label: string;
    /** dovětek do přístupného jména, např. „ – anglická verze dokumentu“ */
    note: string;
}

interface Props {
    href: string;
    title: string;
    /** jazyk NÁZVU (řídí výslovnost čtečky) i cílového souboru */
    lang: DocSetEnum;
    newWindow?: boolean;
    /** volitelný sekundární odkaz na protějšek v druhé sadě */
    alt?: AltLink;
}

/*
    Jedna položka seznamu dokumentů ke stažení. Odkaz míří buď do CMS veřejného webu
    (absolutní URL sestavená v documents.data.ts), nebo na interní routu IS2.
 */
const DocumentItem = ({
    href,
    title,
    lang,
    newWindow = true,
    alt,
}: Props): ReactElement => (
    <li className={styles.item}>
        <a
            href={href}
            hrefLang={lang}
            lang={lang === DocSetEnum.en ? DocSetEnum.en : undefined}
            {...(newWindow && { target: '_blank', rel: 'noreferrer' })}
        >
            {title}
        </a>

        {alt && (
            <a
                className={styles.altLink}
                href={alt.href}
                hrefLang={alt.lang}
                title={alt.title}
                target="_blank"
                rel="noreferrer"
            >
                {/*
                    Vizuálně skrytý REÁLNÝ text, ne aria-label: stránka má lang="cs",
                    takže aria-label by anglický název přečetl český hlas.
                 */}
                <span aria-hidden="true">{alt.label}</span>
                <span className={styles.visuallyHidden} lang={alt.lang}>
                    {alt.title}
                </span>
                <span className={styles.visuallyHidden}>{alt.note}</span>
            </a>
        )}
    </li>
);

export default DocumentItem;
